import React from "react";
import classNames from "classnames";
import { EditIcon } from "@/shared/icons";
import type { ButtonProps } from "antd/lib";
import { AppButton } from "../../AppButton";
import baseBtn from "../styles.module.scss";
import styles from "./styles.module.scss";

export const EditButton: React.FC<ButtonProps> = ({ children, className, ...props }) => {
  return (
    <AppButton
      icon={<EditIcon />}
      className={classNames(baseBtn["contacts-btn"], styles["edit-btn"], className)}
      {...props}
    >
      {children}
    </AppButton>
  );
};
